import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const weekdays = [
  ["MONDAY", "Pn"],
  ["TUESDAY", "Wt"],
  ["WEDNESDAY", "Śr"],
  ["THURSDAY", "Cz"],
  ["FRIDAY", "Pt"],
  ["SATURDAY", "So"],
  ["SUNDAY", "Nd"]
];

const EmployeeAvailability = ({ availability, onInputChange, onWeekdayChange, onRemove, readOnly = false }) => {
  const selectedDays = Array.isArray(availability.daysOfWeek) ? availability.daysOfWeek : [];
  const recurring = availability.recurrence === "WEEKLY";

  return (
    <div className="border rounded p-3">
      {readOnly && (
        <div className="alert alert-info py-2 mb-3">
          Sezonowa pełna dostępność: <strong>{availability.seasonalLabel || "bez nazwy"}</strong> ({availability.dateFrom}–{availability.dateTo}). Zarządzaj nią z poziomu „Grafik dostępności → Sterowanie sezonowością”.
        </div>
      )}
      <div className="row g-2 align-items-end">
        <div className="col-md-2">
          <label className="form-label">Rodzaj</label>
          <select className="form-select" disabled={readOnly} value={availability.type || "AVAILABLE"} onChange={e => onInputChange(e, availability, "type")}>
            <option value="AVAILABLE">Dostępny</option>
            <option value="PREFERRED">Preferowany</option>
            <option value="UNAVAILABLE">Niedostępny</option>
          </select>
        </div>

        <div className="col-md-2">
          <label className="form-label">Od</label>
          <input type="date" className="form-control" disabled={readOnly} value={availability.dateFrom || ""} onChange={e => onInputChange(e, availability, "dateFrom")} />
        </div>

        <div className="col-md-2">
          <label className="form-label">Do</label>
          <input type="date" className="form-control" disabled={readOnly} value={availability.dateTo || ""} onChange={e => onInputChange(e, availability, "dateTo")} />
        </div>

        <div className="col-md-1">
          <label className="form-label">Godz. od</label>
          <input type="time" className="form-control" disabled={readOnly} value={(availability.timeFrom || "").slice(0, 5)} onChange={e => onInputChange(e, availability, "timeFrom")} />
        </div>

        <div className="col-md-1">
          <label className="form-label">Godz. do</label>
          <input type="time" className="form-control" disabled={readOnly} value={(availability.timeTo || "").slice(0, 5)} onChange={e => onInputChange(e, availability, "timeTo")} />
        </div>

        <div className="col-md-2">
          <label className="form-label">Powtarzanie</label>
          <select className="form-select" disabled={readOnly} value={availability.recurrence || "NONE"} onChange={e => onInputChange(e, availability, "recurrence")}>
            <option value="NONE">Każdy dzień okresu</option>
            <option value="WEEKLY">Wybrane dni tygodnia</option>
          </select>
        </div>

        <div className="col-md-1 ms-auto text-end">
          <button type="button" className="btn btn-outline-danger" disabled={readOnly} onClick={onRemove}>
            <FontAwesomeIcon icon={faTrashAlt} />
          </button>
        </div>
      </div>

      {recurring && (
        <div className="d-flex flex-wrap gap-2 mt-3">
          {weekdays.map(([day, label]) => (
            <label key={day} className="btn btn-sm btn-outline-secondary mb-0">
              <input
                type="checkbox"
                className="me-1"
                checked={selectedDays.includes(day)}
                disabled={readOnly}
                onChange={() => onWeekdayChange(availability, day)}
              />
              {label}
            </label>
          ))}
        </div>
      )}

      <div className="mt-3">
        <label className="form-label">Uwagi</label>
        <input type="text" className="form-control" disabled={readOnly} value={availability.comments || ""} onChange={e => onInputChange(e, availability, "comments")} />
      </div>
    </div>
  );
};

export default EmployeeAvailability;
